import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { usePageMeta } from "@/hooks/usePageMeta";

const services = [
  {
    icon: "ri-film-line",
    title: "电影频道",
    desc: "涵盖国产、欧美、日韩等地高分电影，类型齐全，支持按地区、年份与评分筛选。",
  },
  {
    icon: "ri-tv-2-line",
    title: "电视剧频道",
    desc: "汇集都市、古装、悬疑、科幻等热门剧集，全集更新，追剧更省心。",
  },
  {
    icon: "ri-mic-line",
    title: "综艺频道",
    desc: "美食、竞技、生活观察类综艺一应俱全，轻松解压，适合全家一起看。",
  },
];

const contacts = [
  { icon: "ri-mail-line", label: "合作邮箱", value: "support@xigua-video.example" },
  { icon: "ri-customer-service-2-line", label: "在线客服", value: "周一至周日 09:00 - 21:00" },
  { icon: "ri-wechat-line", label: "官方公众号", value: "西瓜视频免费（演示）" },
  { icon: "ri-map-pin-line", label: "办公地址", value: "某市中心影视创意园 A 座 12 层" },
];

export default function About() {
  usePageMeta({
    title: "关于我们-西瓜视频免费",
    description:
      "了解西瓜视频免费：一个专注高清影视内容的免费在线观看平台，提供电影、电视剧、综艺分类浏览与快捷搜索服务。",
    keywords: "西瓜视频免费,关于我们,免费影视平台,在线视频观看",
  });

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6 py-6 md:py-10">
      <Breadcrumb items={[{ label: "关于我们" }]} />

      <section className="mt-4">
        <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
          关于西瓜视频免费
        </h1>
        <p className="mt-4 max-w-3xl text-sm md:text-base leading-relaxed text-foreground-700">
          西瓜视频免费是一个以高清在线观看为核心的影视内容平台。我们希望把散落各处的影视信息整理得更有序，
          让每一位用户都能在几步之内找到想看的节目。无论是想找一部电影放松一晚，还是想追一部正在热播的剧集，
          又或者只是想随便看看轻松的综艺，你都可以在这里快速开始。
        </p>
      </section>

      <section className="mt-10">
        <h2 className="font-heading text-lg md:text-2xl font-bold text-foreground-950">
          我们提供什么
        </h2>
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3">
          {services.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-100 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="rounded-lg bg-secondary-100 p-6 md:p-8">
          <h2 className="font-heading text-lg md:text-2xl font-bold text-foreground-950">
            联系方式
          </h2>
          <ul className="mt-5 space-y-4">
            {contacts.map((item) => (
              <li key={item.label} className="flex items-start gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-50 text-primary-600">
                  <i className={item.icon} />
                </span>
                <div>
                  <p className="text-xs text-foreground-500">{item.label}</p>
                  <p className="text-sm text-foreground-900">{item.value}</p>
                </div>
              </li>
            ))}
          </ul>
          <p className="mt-5 text-xs text-foreground-500">
            以上联系方式为演示用虚拟示例，不用于真实业务联系。
          </p>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
          <h2 className="font-heading text-lg md:text-2xl font-bold text-foreground-950">
            使用说明
          </h2>
          <ol className="mt-5 space-y-4">
            {[
              "通过顶部导航进入电影、电视剧或综艺频道，查看对应分类内容。",
              "使用搜索框输入片名、导演或演员，快速定位想看的内容。",
              "在分类页使用左侧筛选与排序，缩小范围找到更合适的选择。",
              "进入详情页可查看影片信息、收藏影片并分享链接。",
            ].map((text, index) => (
              <li key={text} className="flex items-start gap-3">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xs font-label font-semibold text-background-50">
                  {index + 1}
                </span>
                <p className="text-sm leading-relaxed text-foreground-700">{text}</p>
              </li>
            ))}
          </ol>
          <p className="mt-5 text-xs text-foreground-500">
            收藏功能保存于当前浏览器本地，刷新页面后仍会保留。
          </p>
        </div>
      </section>

      <section className="mt-10 rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
        <h2 className="font-heading text-lg md:text-2xl font-bold text-foreground-950">
          版权声明
        </h2>
        <p className="mt-4 max-w-4xl text-sm leading-relaxed text-foreground-700">
          本站为演示性质的前端站点，所有影片名称、简介、演职人员与封面图均为虚拟示例数据，
          播放器为界面演示，不接入任何真实视频流资源，也不提供视频下载服务。
          如本站内容无意中侵犯到您的权益，请通过上方联系方式与我们取得联系，我们会及时处理。
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-film-line" />
            浏览电影
          </Link>
        </div>
      </section>
    </div>
  );
}